import React from "react";
import { ViewerProps, ViewerState } from "./interface";
import { withRouter } from "react-router-dom";
import BookUtil from "../../utils/file/bookUtil";
import PopupMenu from "../../components/popups/popupMenu";
import Background from "../../components/background";
import toast from "react-hot-toast";
import StyleUtil from "../../utils/reader/styleUtil";
import "./index.css";
import { htmlMouseEvent, bindDragScroll } from "../../utils/reader/mouseEvent";
import ImageViewer from "../../components/imageViewer";
import { getIframeDoc } from "../../utils/reader/docUtil";
import PopupBox from "../../components/popups/popupBox";
import Note from "../../models/Note";
import PageWidget from "../pageWidget";
import {
  getPageWidth,
  getParserRegex,
  getPdfPassword,
  getServerRegion,
  showDownloadProgress,
  throttle,
} from "../../utils/common";
import _ from "underscore";
import { ConfigService } from "../../assets/lib/kookit-extra-browser.min";
import * as Kookit from "../../assets/lib/kookit.min";
import PopupRefer from "../../components/popups/popupRefer";
import { ocrTesseractLangList } from "../../constants/dropdownList";
import DatabaseService from "../../utils/storage/databaseService";
import { getOcrResult } from "../../utils/request/reader";
import { BookHelper } from "../../assets/lib/kookit.min";
import { translatePageJson } from "../../utils/translation/deepseek";
import { TranslationItem, getPageCache, loadAllPageCache } from "../../utils/translation/cache";
declare var window: any;
let lock = false;
function esc(s: string) { return s.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;"); }

class Viewer extends React.Component<ViewerProps, ViewerState> {
  private resizeHandler: (() => void) | null = null;
  private _renditionCleanups: Array<() => void> = [];
  lock: boolean;
  constructor(props: ViewerProps) {
    super(props);
    this.state = {
      cfiRange: null,
      contents: null,
      rect: null,
      key: "",
      isFirst: true,
      chapterTitle:
        ConfigService.getObjectConfig(
          this.props.currentBook.key,
          "recordLocation",
          {}
        ).chapterTitle || "",
      isDisablePopup: ConfigService.getReaderConfig("isDisablePopup") === "yes",
      isTouch: ConfigService.getReaderConfig("isTouch") === "yes",
      chapterDocIndex: parseInt(
        ConfigService.getObjectConfig(
          this.props.currentBook.key,
          "recordLocation",
          {}
        ).chapterDocIndex || 0
      ),
      pageOffset: "",
      pageWidth: "",
      chapter: "",
      rendition: null,
      rightPanelHtml: "",
      contrastPageCache: {} as Record<number, TranslationItem[]>,
      contrastVisiblePage: 0,
      isContrastMaximized: false,
    };
    this.lock = false;
  }
  UNSAFE_componentWillMount() {
    this.props.handleFetchBookmarks();
    this.props.handleFetchNotes();
    this.props.handleFetchBooks();
    this.props.handleFetchPlugins();
  }
  componentDidMount() {
    // 一次性清理数据库中 cfi 为空的脏笔记（防止 Kookit 库内 JSON.parse 崩溃）
    this._cleanBadNotes();
    this.handleRenderBook();
    //make sure page width is always 12 times, section = Math.floor(element.clientWidth / 12), or text will be blocked
    this.setState(
      getPageWidth(
        this.props.readerMode,
        this.props.scale,
        parseInt(this.props.margin),
        this.props.isNavLocked,
        this.props.isSettingLocked
      )
    );
    this.props.handleRenderBookFunc(this.handleRenderBook);
    this.resizeHandler = throttle(() => {
      this.setState(
        getPageWidth(
          this.props.readerMode,
          this.props.scale,
          parseInt(this.props.margin),
          this.props.isNavLocked,
          this.props.isSettingLocked
        )
      );
      this.handleRenderBook();
    });
    window.addEventListener("resize", this.resizeHandler);
  }
  componentWillUnmount() {
    if (this.resizeHandler) {
      window.removeEventListener("resize", this.resizeHandler);
      this.resizeHandler = null;
    }
    this._renditionCleanups.forEach(fn => { try { fn(); } catch {} });
    this._renditionCleanups = [];
  }
  async UNSAFE_componentWillReceiveProps(nextProps: ViewerProps) {
    if (
      nextProps.margin !== this.props.margin ||
      nextProps.scale !== this.props.scale ||
      nextProps.readerMode !== this.props.readerMode ||
      nextProps.isNavLocked !== this.props.isNavLocked ||
      nextProps.isSettingLocked !== this.props.isSettingLocked
    ) {
      this.setState(
        getPageWidth(
          nextProps.readerMode,
          nextProps.scale,
          parseInt(nextProps.margin),
          nextProps.isNavLocked,
          nextProps.isSettingLocked
        )
      );
    }
  }
  _cleanBadNotes = async () => {
    try {
      const all = await DatabaseService.getAllRecords("notes");
      if (!all?.length) return;
      let fixed = 0;
      for (const item of all) {
        let dirty = false;
        try { JSON.parse(item.cfi); } catch { item.cfi = "{}"; dirty = true; }
        try { JSON.parse(item.range); } catch { item.range = "{}"; dirty = true; }
        if (dirty) { await DatabaseService.saveRecord(item, "notes"); fixed++; }
      }
      if (fixed) console.log(`[contrast] 修复了 ${fixed} 条脏笔记（cfi/range 为空）`);
    } catch {}
  };

  handleHighlight = async (rendition: any) => {
    if (!rendition) return;
    let highlighters: any = await DatabaseService.getRecordsByBookKey(
      this.props.currentBook.key,
      "notes"
    );
    if (!highlighters) return;
    // 修复旧脏数据：cfi/range 为空字符串会导致库内 JSON.parse 崩溃
    highlighters.forEach((item: any) => {
      try { JSON.parse(item.cfi); } catch { item.cfi = "{}"; }
      try { JSON.parse(item.range); } catch { item.range = "{}"; }
    });
    let highlightersByChapter = highlighters.filter((item: Note) => {
      let cfi: any;
      try { cfi = JSON.parse(item.cfi); } catch { cfi = {}; }
      if (cfi.cfi) {
        // epub from 1.5.2 or older
        return (
          item.chapter ===
          rendition.getChapterDoc()[this.state.chapterDocIndex].label
        );
      } else if (cfi.fingerprint) {
        // pdf from 1.7.4 or older
        return cfi.page - 1 === this.state.chapterDocIndex;
      } else {
        return item.chapterIndex === this.state.chapterDocIndex;
      }
    });
    if (this.props.currentBook.format === "PDF") {
      highlightersByChapter = highlightersByChapter.map((item: Note) => {
        let cfi: any;
        try { cfi = JSON.parse(item.cfi); } catch { return item; }
        if (cfi.fingerprint) {
          item.chapterIndex = cfi.page - 1;
          cfi.chapterDocIndex = cfi.page - 1 + "";
          cfi.chapterHref = "title" + (cfi.page - 1);
          item.cfi = JSON.stringify(cfi);
        }

        return item;
      });
    }
    // 用全新对象传给 renderHighlighters，确保 cfi/range 合法 JSON
    const safe1 = highlightersByChapter.map(item => ({
      ...item,
      cfi: (() => { try { JSON.parse(item.cfi); return item.cfi; } catch { return "{}"; } })(),
      range: (() => { try { JSON.parse(item.range); return item.range; } catch { return "{}"; } })()
    }));
    await rendition.renderHighlighters(safe1, this.handleNoteClick);
    if (
      this.props.currentBook.format === "PDF" &&
      (this.props.readerMode === "double" ||
        this.props.readerMode === "scroll") &&
      !ConfigService.getAllListConfig("convertPDFBooks").includes(
        this.props.currentBook.key
      )
    ) {
      let highlightersByChapter = highlighters.filter((item: Note) => {
        let cfi: any;
        try { cfi = JSON.parse(item.cfi); } catch { cfi = {}; }
        if (cfi.fingerprint) {
          // pdf from 1.7.4 or older
          return cfi.page === this.state.chapterDocIndex;
        } else {
          return item.chapterIndex === this.state.chapterDocIndex + 1;
        }
      });
      if (this.props.currentBook.format === "PDF") {
        highlightersByChapter = highlightersByChapter.map((item: Note) => {
          let cfi: any;
          try { cfi = JSON.parse(item.cfi); } catch { cfi = {}; }
          if (cfi.fingerprint) {
            item.chapterIndex = cfi.page - 1;
            cfi.chapterDocIndex = cfi.page - 1 + "";
            cfi.chapterHref = "title" + (cfi.page - 1);
            item.cfi = JSON.stringify(cfi);
          }

          return item;
        });
      }
      const safe2 = highlightersByChapter.map(item => ({
        ...item,
        cfi: (() => { try { JSON.parse(item.cfi); return item.cfi; } catch { return "{}"; } })(),
        range: (() => { try { JSON.parse(item.range); return item.range; } catch { return "{}"; } })()
      }));
      await rendition.renderHighlighters(safe2, this.handleNoteClick);
    }
  };
  handleNoteClick = (event: Event) => {
    this.props.handleNoteKey((event.target as any).dataset.key);
    this.props.handleMenuMode("note");
    this.props.handleOpenMenu(true);
  };
  handleRenderBook = async () => {
    if (lock) return;
    let { key, path, format, name } = this.props.currentBook;
    this.props.handleHtmlBook(null);
    if (this.state.rendition) {
      this.state.rendition.removeContent();
    }
    if (
      ConfigService.getAllListConfig("seperateStyleBooks").includes(
        this.props.currentBook?.key
      )
    ) {
      window.currentBookKey = this.props.currentBook.key;
      this.props.handleBackgroundColor(
        ConfigService.getReaderConfig("backgroundColor") || ""
      );
    }
    let isCacheExsit = await BookUtil.isBookExist("cache-" + key, "zip", path);
    BookUtil.fetchBook(
      isCacheExsit ? "cache-" + key : key,
      isCacheExsit ? "zip" : format.toLowerCase(),
      true,
      path
    ).then(async (result: any) => {
      if (!result) {
        if (this.props.defaultSyncOption) {
          let timer = showDownloadProgress(
            this.props.defaultSyncOption,
            "cloud",
            this.props.currentBook.size
          );
          let result = await BookUtil.downloadBook(key, format.toLowerCase());
          clearInterval(timer);
          toast.dismiss("offline-book");
          if (result) {
            toast.success(this.props.t("Download successful"));
          } else {
            toast.error(this.props.t("Book not exists"));
          }
        } else {
          toast.error(this.props.t("Book not exists"));
          return;
        }
      }
      let rendition = BookHelper.getRendition(
        result,
        {
          format: isCacheExsit ? "CACHE" : format,
          readerMode: this.props.readerMode === "contrast" ? "scroll" : this.props.readerMode,
          charset: this.props.currentBook.charset,
          animation:
            ConfigService.getReaderConfig("isSliding") === "yes"
              ? "sliding"
              : "",
          convertChinese: ConfigService.getReaderConfig("convertChinese"),
          bookLayout: ConfigService.getReaderConfig("bookLayout") || "",
          parserRegex: getParserRegex(
            this.props.currentBook.format,
            this.props.currentBook.key
          ),
          fullTranslationMode:
            ConfigService.getAllListConfig("fullTranslationBooks").includes(
              this.props.currentBook.key
            ) && this.props.isAuthed
              ? ConfigService.getReaderConfig("fullTranslationMode")
              : "no",
          textOrientation: ConfigService.getReaderConfig("textOrientation"),
          isDarkMode:
            ConfigService.getReaderConfig("backgroundColor") ===
            "rgba(44,47,49,1)"
              ? "yes"
              : "no",
          backgroundColor: ConfigService.getReaderConfig("backgroundColor"),
          isMobile: "no",
          isIndent: ConfigService.getReaderConfig("isIndent"),
          isHyphenation: ConfigService.getReaderConfig("isHyphenation"),
          isStartFromEven: ConfigService.getReaderConfig("isStartFromEven"),
          isAllowScript: ConfigService.getReaderConfig("isAllowScript"),
          isBionic: ConfigService.getReaderConfig("isBionic"),
          password: getPdfPassword(this.props.currentBook),
          scale: parseFloat(this.props.scale),
          isConvertPDF: ConfigService.getAllListConfig(
            "convertPDFBooks"
          ).includes(this.props.currentBook.key)
            ? "yes"
            : "no",
          ocrLang: ConfigService.getReaderConfig("ocrLang")
            ? ConfigService.getReaderConfig("ocrLang")
            : ConfigService.getReaderConfig("ocrEngine") === "tesseract"
              ? ocrTesseractLangList.find(
                  (item) => item.lang === ConfigService.getReaderConfig("lang")
                )?.value || "chi_sim"
              : ConfigService.getReaderConfig("ocrEngine") === "paddle"
                ? "standard_v5_mobile"
                : "standard_v5_mobile",
          externalWorker: {
            recognize: getOcrResult,
          },
          ocrEngine: ConfigService.getReaderConfig("ocrEngine") || "paddle",
          serverRegion:
            getServerRegion() === "china" && this.props.isAuthed
              ? "china"
              : "global",
          paraSpacingValue:
            ConfigService.getReaderConfig("paraSpacingValue") || "1.5",
          titleSizeValue:
            ConfigService.getReaderConfig("titleSizeValue") || "1.2",
          isScannedPDF:
            this.props.currentBook.description.indexOf("scanned") > -1
              ? "yes"
              : "no",
        },
        Kookit
      );
      // Wait for React to flush DOM updates (getPageWidth) before rendering
      await new Promise(r => requestAnimationFrame(r));
      if (this.props.currentBook.format === "TXT") {
        let bookLocation = ConfigService.getObjectConfig(
          this.props.currentBook.key,
          "recordLocation",
          {}
        );
        await rendition.renderTo(
          document.getElementById("page-area"),
          bookLocation
        );
      } else {
        await rendition.renderTo(document.getElementById("page-area"));
      }

      await this.handleRest(rendition);
      this.props.handleReadingState(true);

      ConfigService.setListConfig(this.props.currentBook.key, "recentBooks");
      document.title = name + " - Koodo Reader";
    });
  };

  handleRest = async (rendition: any) => {
    htmlMouseEvent(
      rendition,
      this.props.currentBook.key,
      this.props.readerMode,
      this.props.currentBook.format,
      this.props.handleScale,
      this.props.renderBookFunc
    );
    let chapters = rendition.getChapter();
    let chapterDocs = rendition.getChapterDoc();
    let flattenChapters = rendition.flatChapter(chapters);
    this.props.handleHtmlBook({
      key: this.props.currentBook.key,
      chapters,
      flattenChapters,
      rendition: rendition,
    });
    this.setState({ rendition });

    if (
      this.props.currentBook.format === "PDF" &&
      !ConfigService.getAllListConfig("convertPDFBooks").includes(
        this.props.currentBook.key
      )
    ) {
    } else {
      StyleUtil.addDefaultCss(this.props.currentBook.key);
    }
    let bookLocation: {
      text: string;
      count: string;
      chapterTitle: string;
      chapterDocIndex: string;
      chapterHref: string;
      percentage: string;
      cfi: string;
      page: string;
      xpath: string;
    } = ConfigService.getObjectConfig(
      this.props.currentBook.key,
      "recordLocation",
      {}
    );
    if (chapterDocs.length > 0) {
      if (
        ConfigService.getReaderConfig("isEnableKoReaderSync") === "yes" &&
        bookLocation.xpath
      ) {
        await rendition.goToXpath(bookLocation.xpath);
      } else {
        await rendition.goToPosition(
          JSON.stringify({
            text: bookLocation.text || "",
            chapterTitle: bookLocation.chapterTitle || "",
            page: bookLocation.page || "",
            chapterDocIndex: bookLocation.chapterDocIndex || 0,
            chapterHref: bookLocation.chapterHref || "",
            count: bookLocation.hasOwnProperty("cfi")
              ? "ignore"
              : bookLocation.count || 0,
            percentage: bookLocation.percentage,
            cfi: bookLocation.cfi,
            isFirst: true,
          })
        );
      }
    }
    this._renditionCleanups.forEach(fn => { try { fn(); } catch {} });
    this._renditionCleanups = [];
    const onRendered = async () => {
      this.handleLocation();
      let bookLocation: {
        text: string;
        count: string;
        chapterTitle: string;
        chapterDocIndex: string;
        chapterHref: string;
      } = ConfigService.getObjectConfig(
        this.props.currentBook.key,
        "recordLocation",
        {}
      );

      let chapter =
        bookLocation.chapterTitle ||
        (this.props.htmlBook && this.props.htmlBook.flattenChapters[0]
          ? ""
          : "Unknown chapter");
      let chapterDocIndex = 0;
      if (bookLocation.chapterDocIndex) {
        chapterDocIndex = parseInt(bookLocation.chapterDocIndex);
      } else {
        chapterDocIndex =
          bookLocation.chapterTitle && this.props.htmlBook
            ? _.findLastIndex(
                this.props.htmlBook.flattenChapters.map((item) => {
                  item.label = item.label.trim();
                  return item;
                }),
                {
                  label: bookLocation.chapterTitle.trim(),
                }
              )
            : 0;
      }
      this.props.handleCurrentChapter(chapter);
      this.props.handleCurrentChapterIndex(chapterDocIndex);

      this.setState({
        chapter,
        chapterDocIndex,
      });
      if (
        this.props.currentBook.format === "PDF" &&
        !ConfigService.getAllListConfig("convertPDFBooks").includes(
          this.props.currentBook.key
        )
      ) {
      } else {
        StyleUtil.addDefaultCss(this.props.currentBook.key);
      }
      // rendition.tranformText();
      this.handleBindGesture();
      if (
        this.props.readerMode === "contrast" ||
        ConfigService.getReaderConfig("readerMode") === "contrast"
      ) {
        // 启用长按拖拽滚动（renderTo 已完成）
        bindDragScroll(this.props.currentBook.format, this.props.currentBook.key);
        // 启动时从本地缓存批量恢复到内存
        loadAllPageCache(this.props.currentBook.key).then(cache => {
          if (Object.keys(cache).length > 0) {
            this.setState(prev => ({
              contrastPageCache: { ...prev.contrastPageCache, ...cache }
            }));
          }
        });
        // 以正下方 ProgressPanel 的页码为准，监听 rendition 的 page-changed 事件
        const tryLoadCache = async (idx: number) => {
          let items = this.state.contrastPageCache[idx];
          if (!items) {
            const disk = await getPageCache(this.props.currentBook.key, idx);
            if (disk?.items?.length) {
              items = disk.items;
              this.setState(prev => ({
                contrastPageCache: { ...prev.contrastPageCache, [idx]: items! }
              }));
            }
          }
          if (items) this.renderContrastHTML(items, idx);
        };

        const syncPage = async () => {
          try {
            const info = await rendition.getProgress();
            const idx = (info?.currentPage || 1) - 1;
            if (idx >= 0) {
              if (idx !== this.state.contrastVisiblePage) {
                this.setState({ contrastVisiblePage: idx });
              }
              // 首次加载或切页时都尝试加载缓存
              await tryLoadCache(idx);
            }
          } catch {}
        };
        rendition.on("page-changed", syncPage);
        this._renditionCleanups.push(() => {
          try { rendition.off("page-changed", syncPage); } catch {}
        });
        syncPage();
      }
      await this.handleHighlight(rendition);
      lock = true;
      setTimeout(function () {
        lock = false;
      }, 1000);
      return false;
    };
    rendition.on("rendered", onRendered);
    this._renditionCleanups.push(() => {
      try { rendition.off("rendered", onRendered); } catch {}
    });
    if (
      this.props.currentBook.format === "TXT" &&
      rendition.format !== "CACHE"
    ) {
      if (
        flattenChapters.length > 0 &&
        flattenChapters[0].label === "Chapter 0"
      ) {
        return;
      }
      setTimeout(async () => {
        await rendition.refreshContent();
        let chapters = rendition.getChapter();
        let flattenChapters = rendition.flatChapter(chapters);
        this.props.handleHtmlBook({
          key: this.props.currentBook.key,
          chapters,
          flattenChapters,
          rendition: rendition,
        });
      }, 1000);
    }
  };

  handleLocation = () => {
    if (!this.props.htmlBook) {
      return;
    }
    let position = this.props.htmlBook.rendition.getPosition();
    ConfigService.setObjectConfig(
      this.props.currentBook.key,
      position,
      "recordLocation"
    );
  };
  handleBindGesture = () => {
    let docs = getIframeDoc(
      this.props.currentBook.format,
      this.props.currentBook.key
    );
    for (let i = 0; i < docs.length; i++) {
      let doc = docs[i];
      if (!doc) continue;
      doc.addEventListener("click", () => {
        this.props.handleLeaveReader("left");
        this.props.handleLeaveReader("right");
        this.props.handleLeaveReader("top");
        this.props.handleLeaveReader("bottom");
      });
      doc.addEventListener("mouseup", (event) => {
        if (
          this.props.currentBook.format === "PDF" &&
          !ConfigService.getAllListConfig("convertPDFBooks").includes(
            this.props.currentBook.key
          )
        ) {
          let ownerDoc = (event.target as HTMLElement).ownerDocument;
          let targetIframe = ownerDoc?.defaultView?.frameElement;
          let id = targetIframe?.getAttribute("id") || "";
          let chapterDocIndex = id ? parseInt(id.split("-").reverse()[0]) : 0;
          this.setState({ chapterDocIndex });
        }

        if (this.state.isDisablePopup) {
          if (doc!.getSelection()!.toString().trim().length === 0) {
            let rect = doc!
              .getSelection()!
              .getRangeAt(0)
              .getBoundingClientRect();
            this.setState({ rect });
          }
        }
        if (this.state.isDisablePopup) return;
        let selection = doc!.getSelection();
        if (!selection || selection.rangeCount === 0) return;

        var rect = selection.getRangeAt(0).getBoundingClientRect();
        this.setState({ rect });
      });
      doc.addEventListener("contextmenu", (event) => {
        if (
          this.props.currentBook.format === "PDF" &&
          !ConfigService.getAllListConfig("convertPDFBooks").includes(
            this.props.currentBook.key
          )
        ) {
          let ownerDoc = (event.target as HTMLElement).ownerDocument;
          let targetIframe = ownerDoc?.defaultView?.frameElement;
          let id = targetIframe?.getAttribute("id") || "";
          let chapterDocIndex = id ? parseInt(id.split("-").reverse()[0]) : 0;
          this.setState({ chapterDocIndex });
        }
        if (document.location.href.indexOf("localhost") === -1) {
          event.preventDefault();
        }

        if (!this.state.isDisablePopup && !this.state.isTouch) return;

        if (
          !doc!.getSelection() ||
          doc!.getSelection()!.toString().trim().length === 0
        ) {
          return;
        }
        let selection = doc!.getSelection();

        if (!selection || selection.rangeCount === 0) return;
        var rect = selection.getRangeAt(0).getBoundingClientRect();
        this.setState({ rect });
      });
    }
  };
  // ── Contrast mode: per-page translation ──────────────────────────

  /** 从单页 iframe 提取原始文本（不切分，交给 AI 分段） */
  _getPageRawText = (pageIdx: number): string => {
    const docs = getIframeDoc(this.props.currentBook.format, this.props.currentBook.key);
    if (docs.length > 1) {
      const pageDoc = docs[pageIdx + 1];
      return pageDoc?.body?.innerText?.trim() || "";
    } else if (docs.length === 1) {
      return docs[0]?.body?.innerText?.trim() || "";
    }
    return "";
  };

  _activeTranslations: Set<number> = new Set();
  _preloadTimer: any = null;

  handleContrastTranslate = async (pageIdx?: number) => {
    const idx = pageIdx ?? this.state.contrastVisiblePage;

    // 防止同一页重复翻译
    if (this._activeTranslations.has(idx)) return;

    this._activeTranslations.add(idx);
    if (idx === this.state.contrastVisiblePage) {
      this.setState({});
    }

    let rawText = this._getPageRawText(idx);
    if (!rawText) {
      await new Promise(r => setTimeout(r, 300));
      rawText = this._getPageRawText(idx);
    }

    if (!rawText) {
      this._activeTranslations.delete(idx);
      if (idx === this.state.contrastVisiblePage) {
        this.setState({ rightPanelHtml: `<p style='text-align:center;color:#999;padding-top:40%;'>第 ${idx + 1} 页无内容</p>` });
      }
      return;
    }

    if (idx === this.state.contrastVisiblePage) {
      this.setState({ rightPanelHtml: `<p style='text-align:center;color:#999;padding-top:40%;'>正在翻译第 ${idx + 1} 页...</p>` });
    }

    try {
      const items = await translatePageJson(
        this.props.currentBook.key, idx, rawText, "en", "zh", true,
        (stage) => {
          if (idx === this.state.contrastVisiblePage && stage === "translating") {
            this.setState({ rightPanelHtml: `<p style='text-align:center;color:#999;padding-top:40%;'>正在翻译第 ${idx + 1} 页...</p>` });
          }
        }
      );

      if (items.length === 0) {
        this._activeTranslations.delete(idx);
        if (idx === this.state.contrastVisiblePage) {
          this.setState({ rightPanelHtml: `<p style='text-align:center;color:red;padding-top:40%;'>翻译失败：AI 返回为空，请重试</p>` });
        }
        return;
      }

      const newCache = { ...this.state.contrastPageCache, [idx]: items };
      if (idx === this.state.contrastVisiblePage) {
        this.setState({ contrastPageCache: newCache });
        this.renderContrastHTML(items, idx);
      } else {
        this.setState({ contrastPageCache: newCache });
      }
      this._activeTranslations.delete(idx);
      this._preloadAdjacent(idx);
    } catch (e: any) {
      this._activeTranslations.delete(idx);
      if (idx === this.state.contrastVisiblePage) {
        this.setState({ rightPanelHtml: `<p style='text-align:center;color:red;padding-top:40%;'>翻译失败：${esc(e.message || "")}</p>` });
      } else {
        this.forceUpdate();
      }
    }
  };

  _preloadAdjacent = (idx: number) => {
    if (this._preloadTimer) clearTimeout(this._preloadTimer);
    this._preloadTimer = setTimeout(() => {
      [idx - 1, idx + 1].forEach(adj => {
        if (adj >= 0 && !this.state.contrastPageCache[adj] && !this._activeTranslations.has(adj)) {
          const rawText = this._getPageRawText(adj);
          if (rawText) {
            this._activeTranslations.add(adj);
            translatePageJson(this.props.currentBook.key, adj, rawText, "en", "zh")
              .then(items => {
                this._activeTranslations.delete(adj);
                if (items.length > 0 && items.some(i => i.zh)) {
                  this.setState(prev => ({ contrastPageCache: { ...prev.contrastPageCache, [adj]: items } }));
                }
              })
              .catch(() => { this._activeTranslations.delete(adj); this.forceUpdate(); });
          }
        }
      });
    }, 1000);
  };

  renderContrastHTML = (items: TranslationItem[] | undefined, pageIdx: number) => {
    if (!items?.length) return;
    let html = `<div style='margin-bottom:12px;padding-bottom:8px;border-bottom:1px solid #e0e0e0;color:#888;font-size:12px;'>Page ${pageIdx + 1}</div>`;
    for (let i = 0; i < items.length; i++) {
      const en = items[i].en || "";
      const zh = items[i].zh || "";
      html += `<div class='contrast-para' style='margin-bottom:20px;padding-bottom:16px;border-bottom:1px solid #e8e8e8;user-select:text;'>
        <p style='font-size:14px;color:#333;line-height:1.7;margin:0 0 10px;white-space:pre-wrap;user-select:text;'>${esc(en)}</p>
        <p style='font-size:14px;color:#4b73b0;line-height:1.7;margin:0 0 8px;white-space:pre-wrap;user-select:text;'>${esc(zh || "")}</p>
        <button class='save-card-btn' data-idx='${i}' style='font-size:11px;padding:3px 10px;background:#f5f5f5;border:1px solid #ddd;border-radius:4px;cursor:pointer;color:#888;'>💾 保存到卡片</button>
      </div>`;
    }
    this.setState({ rightPanelHtml: html });
  };

  /** 右侧面板点击事件委托，处理保存按钮 → 存入 notes 表（笔记中可查看） */
  _handleRightPanelClick = (e: React.MouseEvent) => {
    const btn = (e.target as HTMLElement).closest(".save-card-btn") as HTMLElement | null;
    if (!btn?.dataset.idx) return;
    const idx = parseInt(btn.dataset.idx);
    const items = this.state.contrastPageCache[this.state.contrastVisiblePage];
    if (!items?.[idx]) return;
    try {
      // 以 Note 格式存入 notes 表：英文原文作为 text，中文翻译作为 notes
      const note = new Note(
        this.props.currentBook.key,
        this.state.chapter || "",
        this.state.chapterDocIndex || 0,
        items[idx].en || "",     // text → 笔记中显示为标注原文
        "{}",                     // cfi（合法 JSON）
        "{}",                     // range（合法 JSON，renderHighlighters 会 JSON.parse）
        items[idx].zh || "",     // notes → 笔记中显示为笔记内容
        "",                       // percentage
        0,                        // color
        []                        // tag
      );
      DatabaseService.saveRecord(note, "notes");
      toast.success(this.props.t("Saved to Knowledge Cards"));
    } catch (e: any) { toast.error(e.message || "Failed"); }
  };

  render() {
    return (
      <>
        {this.props.htmlBook ? (
          <PopupMenu
            {...({
              rendition: this.props.htmlBook.rendition,
              rect: this.state.rect,
              chapterDocIndex: this.state.chapterDocIndex,
              chapter: this.state.chapter,
            } as any)}
          />
        ) : null}
        {this.props.htmlBook ? (
          <PopupRefer
            {...({
              rendition: this.props.htmlBook.rendition,
              chapterDocIndex: this.state.chapterDocIndex,
            } as any)}
          />
        ) : null}
        {this.props.isOpenMenu &&
        this.props.htmlBook &&
        (this.props.menuMode === "dict" ||
          this.props.menuMode === "trans" ||
          this.props.menuMode === "assistant" ||
          this.props.menuMode === "note" ||
          this.props.menuMode === "summary") ? (
          <PopupBox
            {...({
              rendition: this.props.htmlBook.rendition,
              rect: this.state.rect,
              chapterDocIndex: this.state.chapterDocIndex,
              chapter: this.state.chapter,
            } as any)}
          />
        ) : null}
        {this.props.htmlBook && this.props.currentBook.format !== "PDF" && (
          <ImageViewer
            {...({
              isShow: this.props.isShow,
              rendition: this.props.htmlBook.rendition,
              handleEnterReader: this.props.handleEnterReader,
              handleLeaveReader: this.props.handleLeaveReader,
            } as any)}
          />
        )}
        <div
          className={
            this.props.readerMode === "scroll" || this.props.readerMode === "contrast"
              ? "html-viewer-page scrolling-html-viewer-page"
              : "html-viewer-page"
          }
          id="page-area"
          style={
            this.props.readerMode === "scroll" &&
            document.body.clientWidth >= 570
              ? {
                  // marginLeft: this.state.pageOffset,
                  // marginRight: this.state.pageOffset,
                  paddingLeft: "0px",
                  paddingRight: "15px",
                  left: this.state.pageOffset,
                  width: this.state.pageWidth,
                }
              : {
                  left: this.state.pageOffset,
                  width: this.state.pageWidth,
                }
          }
        ></div>
        {this.props.readerMode === "contrast" && (() => {
          const pageIdx = this.state.contrastVisiblePage;
          const isCached = !!this.state.contrastPageCache[pageIdx];
          const isActive = this._activeTranslations.has(pageIdx);
          return (
          <div id="page-area-right" onClick={this._handleRightPanelClick} style={{ position: "fixed", top: 0, right: 0, width: this.state.isContrastMaximized ? "100vw" : "calc(50vw - 20px)", height: "100%", overflow: "auto", padding: "20px", boxSizing: "border-box", background: "#fafaf8", borderLeft: "2px solid #ddd", zIndex: this.state.isContrastMaximized ? 100 : 5, transition: "width 0.3s ease" }}>
            {/* 顶部操作栏 */}
            <div style={{ position: "sticky", top: 0, zIndex: 10, display: "flex", alignItems: "center", gap: "10px", marginBottom: "16px", paddingBottom: "12px", borderBottom: "1px solid #e0e0e0", background: "#fafaf8" }}>
              <span style={{ fontSize: "13px", color: "#888", whiteSpace: "nowrap" }}>
                左侧第 <b style={{ color: "#333" }}>{pageIdx + 1}</b> 页
              </span>
              <button
                onClick={() => this.handleContrastTranslate(pageIdx)}
                disabled={isActive}
                style={{
                  flex: 1,
                  padding: "8px 16px",
                  fontSize: "14px",
                  fontWeight: "bold",
                  border: "none",
                  borderRadius: "6px",
                  cursor: isActive ? "not-allowed" : "pointer",
                  background: isActive
                    ? "#e0e0e0"
                    : isCached ? "#4b73b0" : "#2d8c4a",
                  color: "#fff",
                  opacity: isActive ? 0.6 : 1,
                  transition: "background 0.2s",
                }}
              >
                {isActive
                  ? "⏳ 翻译中..."
                  : isCached
                    ? "🔄 重新翻译"
                    : "🌐 翻译本页"}
              </button>
              <button
                onClick={() => this.setState({ isContrastMaximized: !this.state.isContrastMaximized })}
                title={this.state.isContrastMaximized ? "还原" : "最大化"}
                style={{ background: "#fff", border: "1px solid #ddd", borderRadius: "6px", padding: "4px 10px", cursor: "pointer", fontSize: "16px", flexShrink: 0 }}
              >
                {this.state.isContrastMaximized ? "🗗" : "🗖"}
              </button>
            </div>
            {/* 内容区 */}
            {this.state.rightPanelHtml ? (
              <div style={{ fontSize: "14px" }} dangerouslySetInnerHTML={{ __html: this.state.rightPanelHtml }} />
            ) : (
              <div style={{ textAlign: "center", paddingTop: "30%", color: "#999" }}>
                <p style={{ fontSize: "40px" }}>📖</p>
                <p style={{ fontWeight: "bold", fontSize: "16px", color: "#555" }}>对照翻译面板</p>
                <p style={{ fontSize: "12px" }}>
                  {this._activeTranslations.size > 0
                    ? `后台翻译中（${this._activeTranslations.size} 页）...`
                    : "点击上方按钮翻译左侧当前页"}
                </p>
              </div>
            )}
          </div>
          );
        })()}
        <PageWidget />
        {this.props.isHideBackground ? null : this.props.currentBook.key ? (
          <Background />
        ) : null}
      </>
    );
  }
}
export default withRouter(Viewer as any);
